<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('https://images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 20%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Museum Stories</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Daily reflections, artifact spotlights, and historical notes from Bayou Lacombe.
    </p>
  </div>
</header>

<main class="container stories-container">
  <div class="stories-grid">
    <div class="story-card" *ngFor="let item of blmDaily" [routerLink]="['/daily', item.fields.url]">
      <div class="story-image-wrap" *ngIf="item.fields.images?.[0]?.fields?.file?.url">
        <div class="story-image" [style.background-image]="'url(' + item.fields.images[0].fields.file.url + '?w=600&h=400&fit=fill)'"></div>
        <div class="story-badge">
          <span>{{ item.fields.date }}</span>
        </div>
      </div>

      <div class="story-body">
        <span class="story-tag">Museum Journal</span>
        <h3 class="story-title">{{ item.fields.title }}</h3>
        <p class="story-snippet" [innerHTML]="item.fields.shortDescription | mdToHtml"></p>
        <span class="read-more-link">
          Read Story <mat-icon>arrow_forward</mat-icon>
        </span>
      </div>
    </div>
  </div>
</main>
